import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useForm from '@components/form/hooks/useForm';
import { postResetPassword } from '@actions/auth/postResetPassword';
import { getAuthError, getAuthIsPosting, getAuthPostSuccess } from '@selectors/auth';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useHistory, useLocation } from 'react-router-dom';

const useResetPasswordForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const isPosting = useSelector(getAuthIsPosting);
    const postSuccess = useSelector(getAuthPostSuccess);
    const error = useSelector(getAuthError);

    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('guid') as string;

    const [{ password }, handleChange] = useForm({ password: '' });
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (!code) {
            history.replace('/auth/login');
        }
    }, [code, history]);

    const prevPostSuccess = usePrevious(postSuccess);
    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            setSuccess(true);
        }
    }, [dispatch, postSuccess, prevPostSuccess, setSuccess]);

    const handleCancel = () => {
        history.replace('/auth/login');
    };
    const handleSubmit = () => {
        dispatch(postResetPassword({ password, code }));
    };

    return {
        handleChange,
        handleSubmit,
        isPosting,
        success,
        error,
        handleCancel,
        password,
    };
};

export default useResetPasswordForm;
